import { render, staticRenderFns } from "./ProductsDetails.vue?vue&type=template&id=3f7a59da&scoped=true"
import script from "./ProductsDetails.vue?vue&type=script&lang=js"
export * from "./ProductsDetails.vue?vue&type=script&lang=js"
import style0 from "./ProductsDetails.vue?vue&type=style&index=0&id=3f7a59da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7a59da",
  null
  
)

export default component.exports